// Helper function to convert Entity Name to a URL-friendly tab key
export const toTabKey = (entityName: string): string => {
  if (!entityName) return "";
  return entityName
    .replaceAll(/([a-z])([A-Z])/g, "$1-$2")
    .toLowerCase()
    .replaceAll(/\b(information|scores)\b/g, "")
    .replace(/-$/, "");
};
